import { WebsocketResponse } from "../model/WebsocketResponse";
import { JsonUtil } from "../../cutil/JsonUtil";
import { Meta } from "../../cutil/Meta";
import { ErrorUtil } from "../../api/ErrorUtil";
export class WebsocketService {
    constructor(messageCenter) {
        this.messageCenter = messageCenter;
    }
    async websocketDataSource(pubsub_topic, identityInfo) {
        return new Promise((resolve, reject) => {
            this.messageCenter.on(pubsub_topic, (res) => {
                this.messageCenter.off(pubsub_topic);
                const response = JsonUtil.toModelFromType(WebsocketResponse, res);
                if (!response) {
                    reject(new Meta("Webscoket Error", ErrorUtil.defaultErrorMsg));
                }
                else {
                    if (response.succeed) {
                        if (!response.isPlaceholderMessage) {
                            resolve(response);
                        }
                    }
                    else {
                        reject(new Meta("Webscoket Error", response.errorMsg || ErrorUtil.defaultErrorMsg));
                    }
                }
            }, `${identityInfo?.projectId}_${identityInfo?.edgeId}`);
        });
    }
}
